<template>
  <s-table ref="recordTable"
           :columns="columns"
           :data="loadData"
           :customRow="customRow"
           :rowKey="record => record.id"
           :pagination="{ showTotal: (total) => `共 ${total} 条` }">
  </s-table>
</template>
<script>
import STable from '@/components/Table'
import {
  QueryExpertWorkRecordList
} from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

export default {
  name: 'RecordSTable',
  components: {
    STable
  },
  props: {
    expertId: {
      type: String,
      default: ''
    },
    expertFlag: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      required: true,
      default () {
        return []
      },
    },
    recordVisible: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      customRow: (record, index) => {
        return {
          on: {
            click: () => {
              this.toView('/selectExpertApply/view?id=' + record.applyId)
            }
          }
        }
      },
      loadData: async (parameter) => {
        const data = {
          ...parameter,
          expertId: this.expertId,
          expertFlag: this.expertFlag,
        }
        return QueryExpertWorkRecordList(data)
      }
    }
  },
  watch: {
    recordVisible (val) {
      if (val) {
        this.$refs.recordTable?.refresh()
      }
    }
  },
  methods: {
    toView (url) {
      let routeIndex = this.$router.resolve({
        path: url
      })
      if (!this.readOnly) {
        window.open(routeIndex.href, '_blank')
      }
    }
  }
}
</script>
